
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { BusinessCard, Business } from "./BusinessCard";

interface BusinessTabContentProps {
  businesses: Business[] | undefined;
  isLoading: boolean;
  error: Error | null;
  category: string;
  handleBusinessClick: (id: string) => void;
}

export const BusinessTabContent = ({ 
  businesses, 
  isLoading, 
  error, 
  category,
  handleBusinessClick 
}: BusinessTabContentProps) => {
  const navigate = useNavigate();
  
  if (isLoading) {
    return <div className="text-center py-8">로딩 중...</div>;
  }
  
  if (error) {
    return <div className="text-center py-8 text-red-500">데이터를 불러오는 중 오류가 발생했습니다.</div>;
  }
  
  const filteredBusinesses = businesses?.filter(business => 
    category === "businesses" 
      ? business.category.includes('과외') || business.category.includes('교육')
      : category === "attorney" 
        ? business.category.includes('변호사')
        : category === "realEstate"
          ? business.category.includes('부동산')
          : category === "openChat"
            ? business.category.includes('오픈톡방')
            : category === "koreanMart"
              ? business.category.includes('한인마트')
              : !business.category.includes('과외') && 
                !business.category.includes('교육') && 
                !business.category.includes('변호사') &&
                !business.category.includes('부동산') &&
                !business.category.includes('오픈톡방') &&
                !business.category.includes('한인마트')
  );
  
  if (!filteredBusinesses || filteredBusinesses.length === 0) {
    let message = '';
    let buttonText = '';
    
    if (category === "businesses") {
      message = "아직 등록된 업체나 과외가 없습니다.";
      buttonText = "첫 번째 업체/과외 등록하기";
    } else if (category === "attorney") {
      message = "아직 등록된 변호사가 없습니다.";
      buttonText = "첫 번째 변호사 등록하기";
    } else if (category === "realEstate") {
      message = "아직 등록된 부동산 매물이 없습니다.";
      buttonText = "첫 번째 부동산 매물 등록하기";
    } else if (category === "openChat") {
      message = "아직 등록된 오픈톡방이 없습니다.";
      buttonText = "첫 번째 오픈톡방 등록하기";
    } else if (category === "koreanMart") {
      message = "아직 등록된 한인마트가 없습니다.";
      buttonText = "첫 번째 한인마트 등록하기";
    } else {
      message = "아직 등록된 한인업체가 없습니다.";
      buttonText = "첫 번째 한인업체 등록하기";
    }
    
    return (
      <div className="text-center py-8">
        <p className="text-muted-foreground mb-4">{message}</p>
        <Button onClick={() => navigate('/business-tutoring/write')}>
          {buttonText}
        </Button>
      </div>
    );
  }
  
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {filteredBusinesses.map((business) => (
        <BusinessCard 
          key={business.id} 
          business={business} 
          onClick={() => handleBusinessClick(business.id)} 
          hideImage={true}
        />
      ))}
    </div>
  );
};
